import { render, staticRenderFns } from "./addenvironment.vue?vue&type=template&id=36ba57bd&"
import script from "./addenvironment.vue?vue&type=script&lang=js&"
export * from "./addenvironment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ba57bd')) {
      api.createRecord('36ba57bd', component.options)
    } else {
      api.reload('36ba57bd', component.options)
    }
    module.hot.accept("./addenvironment.vue?vue&type=template&id=36ba57bd&", function () {
      api.rerender('36ba57bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/management/environment/components/addenvironment.vue"
export default component.exports